"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _kx = require("@/api/kx");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'KxFlow',
  data: function data() {
    return {
      activeTab: 'happyFruit',
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      searchForm: {
        uid: '',
        phone: '',
        type: '',
        zoneType: '',
        page: 1,
        limit: 20
      },
      typeOptions: [{
        label: '消费赠送',
        value: 1
      }, {
        label: '直推奖释放扣减',
        value: 2
      }, {
        label: '手动调整',
        value: 3
      }]
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    handleTabClick: function handleTabClick() {
      this.searchForm.uid = '';
      this.searchForm.phone = '';
      this.searchForm.type = '';
      this.searchForm.zoneType = '';
      this.searchForm.page = 1;
      this.getList();
    },
    handleReset: function handleReset() {
      this.searchForm.uid = '';
      this.searchForm.phone = '';
      this.searchForm.type = '';
      this.searchForm.zoneType = '';
      this.getList(1);
    },
    getList: function getList(num) {
      var _this = this;
      this.listLoading = true;
      this.searchForm.page = num || this.searchForm.page;
      var apiMap = {
        happyFruit: _kx.kxFlowHappyFruitApi,
        commission: _kx.kxFlowCommissionApi,
        balance: _kx.kxFlowBalanceApi,
        zoneConsume: _kx.kxFlowZoneConsumeApi
      };
      var apiFn = apiMap[this.activeTab];
      var params = _objectSpread({}, this.searchForm);
      if (this.activeTab === 'zoneConsume') {
        delete params.type;
      } else {
        delete params.zoneType;
      }
      apiFn(params).then(function (res) {
        _this.tableData.data = res.list || [];
        _this.tableData.total = res.total || 0;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
      this.getList();
    }
  }
};